module.exports = __webpack_public_path__ + "img/close.1a4c1979.svg";